/** Phone numbers in E.164 (+237…): same rules as backend apps/core/phone.py (P1-11). */

import { type CountryCode, parsePhoneNumberFromString } from "libphonenumber-js";

export const DEFAULT_REGION: CountryCode = "CM";

export function toE164(raw: string, region: CountryCode = DEFAULT_REGION): string | null {
  let cleaned = raw.trim();
  if (cleaned.startsWith("00")) cleaned = `+${cleaned.slice(2)}`;
  const number = parsePhoneNumberFromString(cleaned, region);
  return number?.isValid() ? number.number : null;
}

export function formatPhone(e164: string): string {
  return parsePhoneNumberFromString(e164)?.formatInternational() ?? e164;
}

export function isEmail(value: string): boolean {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value.trim());
}

/** Sign-in accepts an e-mail or a WhatsApp number. */
export function isValidIdentifier(value: string): boolean {
  return isEmail(value) || toE164(value) !== null;
}
